import React, { createContext } from "react";
import { useAuth } from "../hooks/useAuth";

export const AuthContext = createContext();

export const AuthProvider = (props) => {

    const { children } = props;
    const { usuario, validarLogin, cerrarSesion } = useAuth();

    return (
        <AuthContext.Provider value={{ usuario, validarLogin, cerrarSesion }}>
            { children }
        </AuthContext.Provider>
    )
};